export default __webpack_public_path__ + "static/media/google-play-badge-us.93b902fe.svg";